import Image from "next/image"
import { useLang } from "hooks/useLang"

interface FeatureProps {
    title: string
    description: string
    iconPath: string
}

const FeatureItem = ({ title, description, iconPath }: FeatureProps) => {
    return (
        <div className="rounded-xl py-4 md:mt-2 flex flex-col md:flex-row md:items-start items-center w-full md:w-1/3 mb-4 md:mb-0">
            <div className="w-12 h-12 md:w-14 md:h-14 bg-[#5F6EEF] rounded-full flex-shrink-0 items-center justify-center flex">
                <Image
                    src={iconPath}
                    alt="feature icon"
                    width={30}
                    height={30}
                    className="w-[30px] h-[30px]"
                />
            </div>
            <div className="mt-3 md:mt-0 md:px-4 md:items-start items-center flex flex-col">
                <h2 className="text-lg md:text-xl text-white font-bold capitalize text-center md:text-left">
                    {title}
                </h2>
                <p className="mt-2 text-sm  text-[#B5B5B5] leading-snug text-center md:text-left">
                    {description}
                </p>
            </div>
        </div>
    )
}

const WhyBookOnPassTicketsSection = ({ isLoading }: { isLoading: boolean }) => {
    const { t } = useLang()

    if (isLoading) return null

    return (
        <div className="w-full flex flex-col px-4 md:px-8 py-6 md:py-8 layout md:max-w-[1220px] items-center md:items-start">
            <h2 className="text-2xl md:text-3xl font-bold mb-[10px] text-center md:text-left">
                {t("whyBookOnPasstickets")}
            </h2>

            <div className="flex flex-col md:flex-row md:space-x-6 w-full">
                <FeatureItem
                    iconPath={"/svg/lock.svg"}
                    title={t("whyBookOnPasstickets_feature_1_title")}
                    description={t("whyBookOnPasstickets_feature_1_desc")}
                />

                <FeatureItem
                    iconPath={"/svg/shine.svg"}
                    title={t("whyBookOnPasstickets_feature_2_title")}
                    description={t("whyBookOnPasstickets_feature_2_desc")}
                />

                <FeatureItem
                    iconPath={"/svg/accountShine.svg"}
                    title={t("whyBookOnPasstickets_feature_3_title")}
                    description={t("whyBookOnPasstickets_feature_3_desc")}
                />
            </div>
        </div>
    )
}

export default WhyBookOnPassTicketsSection
